import { render, staticRenderFns } from "./RatingsReceivedByColleaguesTab.vue?vue&type=template&id=0059652c&scoped=true"
import script from "./RatingsReceivedByColleaguesTab.vue?vue&type=script&lang=js"
export * from "./RatingsReceivedByColleaguesTab.vue?vue&type=script&lang=js"
import style0 from "./RatingsReceivedByColleaguesTab.vue?vue&type=style&index=0&id=0059652c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0059652c",
  null
  
)

export default component.exports